import { ICapture, ISegment, IEditParams } from '../../shared/types'

const getCropForAspectRatio = (width, height, aspectRatio) => {
    const [numerator, denominator] = aspectRatio.split(':')
    const ratio = numerator / denominator

    let cropWidth
    let cropHeight

    if (ratio < 1) {
        // "tall" crop
        cropWidth = Math.min(height * ratio, width)
        cropHeight = cropWidth / ratio
    } else {
        // "wide" or square crop
        cropHeight = Math.min(width / ratio, height)
        cropWidth = cropHeight * ratio
    }

    const cropX = width / 2 - cropWidth / 2
    const cropY = height / 2 - height / 2

    return {
        x: cropX,
        y: cropY,
        w: cropWidth,
        h: cropHeight,
    }
}

const base64ToBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data.replace('data:image/png;base64,', ''))
    const byteArrays: Uint8Array[] = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return blob
}

const getFontNameOptions = () => {
    return {
        Nexa: 'NexaBlack',
        Arial: 'Arial',
    }
}

const getFontSizeOptions = (capture: ICapture) => {
    return {
        Small: 0.08 * capture.height,
        Medium: 0.12 * capture.height,
        Large: 0.2 * capture.height,
    }
}

const getFontColorOptions = () => {
    return {
        White: 'white',
        Yellow: 'yellow',
    }
}

const getDefaultEditParams = (capture: ICapture, segment: ISegment) => {
    const fontSizeOptions = getFontSizeOptions(capture)
    const fontColorOptions = getFontColorOptions()
    const fontNameOptions = getFontNameOptions()

    return {
        captionX: capture.width / 2,
        captionY: capture.height / 2,
        captionText: '',
        captionWatermark: '',
        captionFontSize: fontSizeOptions['Medium'],
        captionFontColor: fontColorOptions['White'],
        captionFontName: fontNameOptions['Nexa'],
        trimmedStartTime: 0,
        trimmedEndTime: segment.duration,
        aspectRatio: 'original',
        isMerged: false,
        displayOrder: segment.index,
        displayHidden: false,
    } as IEditParams
}

export {
    getCropForAspectRatio,
    base64ToBlob,
    getFontNameOptions,
    getFontSizeOptions,
    getFontColorOptions,
    getDefaultEditParams,
}
